<template>
	<div class="col-6 spotlight">
		<div class="card">
			<b-form @submit.prevent="validateAndSave"
					@reset.prevent="cancelEdit">
				<div class="card-header pt-2 pb-2" style="min-height: 48px">
					<span>Line Item Info</span>
				</div>
				<div class="list-group list-group-flush">
					<div class="list-group-item pt-1 pb-1">
					<span>
						<b-button type="submit" variant="primary">Save</b-button>
					</span>
						<span class="float-right">
						<b-button type="reset" variant="secondary">Cancel</b-button>
					</span>
					</div>
				</div>
				<div class="card-body">
					<FeedbackPanel></FeedbackPanel>
					<div class="row mb-1">
						<div class="col-4">
							<strong>Source Number</strong>
							<ValidationProvider v-slot="v" ref="Source Number">
								<b-form-input class="job-field form-control"
											  v-model="record.fieldData['Source Number']"/>
							</ValidationProvider>
						</div>
						<div class="col-8">
							<strong>Source</strong>
							<ValidationProvider v-slot="v" ref="Source">
								<v-select :options="sourceOptions"
											   v-model="record.fieldData.Source"></v-select>
							</ValidationProvider>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-4">
							<strong>Lot Number</strong>
							<ValidationProvider v-slot="v" ref="Lot Number">
								<b-form-input class="job-field form-control" v-model="record.fieldData['Lot Number']"/>
							</ValidationProvider>
						</div>
						<div class="col-8">
							<strong>Cause</strong>
							<ValidationProvider v-slot="v" ref="Cause">
								<v-select :options="causeOptions"
											   v-model="record.fieldData.Cause"></v-select>
							</ValidationProvider>
						</div>
					</div>
					<hr/>
					<div class="row mb-1">
						<div class="col-3">
							<div><strong>Pack Qty</strong></div>
							<ValidationProvider v-slot="v" ref="Pack Quantity">
								<b-form-input id="pack-qty" class="job-field form-control"
											  v-model="record.fieldData['Pack Quantity']"/>
							</ValidationProvider>
						</div>
						<div class="col-6">
							<strong>Type</strong>
							<ValidationProvider v-slot="v" ref="Pack Quantity UoM">
								<v-select :options="packQtyTypeValueList"
											   v-model="record.fieldData['Pack Quantity UoM']"></v-select>
							</ValidationProvider>
						</div>
						<div class="col-3">
							<div v-if="isBulk"><strong>% Purity</strong></div>
							<div v-else><strong>% Fill</strong></div>
							<ValidationProvider ref="Percent Fill" v-slot="v">
								<div v-if="isPercentFillStatic" class="job-field">{{ percentFill }}</div>
								<b-form-input v-else class="job-field form-control"
											  v-model="record.fieldData['Percent Fill']"/>
							</ValidationProvider>
						</div>
					</div>
					<!--Pack_Size-->
					<!--Pack_Size_UoM-->
					<div class="row mb-1">
						<div class="col-3">
							<div><strong>Pack Size</strong></div>
							<ValidationProvider ref="Pack Size" v-slot="v">
								<b-form-input id="pack-size" v-if="isBulk" class="job-field form-control"
											  v-model="record.fieldData['Pack Size']"/>
								<div v-else class="job-field">
									{{ record.fieldData['Danox_Dictionary_Final_Code::Package Size Converted LU'] }}
								</div>
							</ValidationProvider>
						</div>
						<div class="col-3">
							<strong>UoM</strong>
							<ValidationProvider v-slot="v" ref="Pack Size UoM">
								<v-select id="pack-size-uom" v-if="isBulk && dynamicUomValueList.length > 1"
											   :options="dynamicUomValueList"
											   class="job-field form-control"
											   v-model="record.fieldData['Pack Size UoM']"></v-select>
								<b-form-input id="pack-size-uom" v-else-if="isBulk" class="job-field form-control"
											  v-model="record.fieldData['Pack Size UoM']"/>
								<div v-else class="job-field ">
									{{ record.fieldData['Danox_Dictionary_Final_Code::Package Size UoM LU'] }}
								</div>
							</ValidationProvider>
						</div>
						<div v-show="hasFactor" class="offset-3 col-3">
							<strong>Converted</strong>
							<div class="job-field ">{{ record.fieldData['converteToBase'] }}</div>
						</div>
					</div>
<!--					<div class="row mb-1">
						<div class="col-3">
							<div><strong>Ordered Qty</strong></div>
							<div class="job-field">{{ record.fieldData['Ordered Quantity CALC'] }}</div>
						</div>
						<div class="col-3">
							<strong>UoM</strong>
							<div class="job-field ">{{ record.fieldData['Ordered Quantity UoM CALC'] }}</div>
						</div>
					</div>-->
<!--					<div class="row mb-1">
						<div class="col-3">
							<div><strong>Shipped Qty</strong></div>
							<div class="job-field">{{ record.fieldData['Reporting Qty'] }}</div>
						</div>
						<div class="col-3">
							<strong>UoM</strong>
							<div class="job-field ">{{ record.fieldData['Reporting UoM'] }}</div>
						</div>
					</div>-->
					<hr v-show="showStageUnitConverter || showUnitConverter"/>
					<div class="row mb-1">
						<div class="col-6 card-title" v-show="showUnitConverter">
							<h6 class="mb-2" style="text-decoration: underline">Unit Converter</h6>
							<div class="row">
								<div class="col-6">
									<div><strong>Amt</strong></div>
									<ValidationProvider ref="YI Package Size Bulk Blend" v-slot="v">
										<b-form-input id="bulk-blend-pack-size" class="job-field form-control"
													  v-model="record.fieldData['YI Package Size Bulk Blend']"/>
									</ValidationProvider>
								</div>
								<div class="col-6">
									<strong>UoM</strong>
									<ValidationProvider v-slot="v" ref="YI Package Size Bulk Blend UoM">
										<v-select
													   :options="yiPkgSizeBulkBlendUoMOptions"
													   v-model="record.fieldData['YI Package Size Bulk Blend UoM']"></v-select>
									</ValidationProvider>
								</div>
							</div>
						</div>
						<div class="col-6 card-title" :class="{'converter-divider': showUnitConverter}"
							 v-show="showStageUnitConverter">
							<h6 class="mb-2" style="text-decoration: underline">Stage Converter</h6>
							<div class="row">
								<div class="col-12">
									<div><strong>Stage</strong></div>
									<ValidationProvider v-slot="v" ref="YI Package Size Bulk Blend Chosen Stage">
										<v-select
													   :options="stagesValueList"
													   v-model="record.fieldData['YI Package Size Bulk Blend Chosen Stage'].currentValue"></v-select>
									</ValidationProvider>
								</div>
							</div>
						</div>
			`		</div>
				</div>
			</b-form>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import BaseEdit from '../BaseEdit'
import lineItemMixin from '../../mixins/line-item'
import router from '../../router'
import NDCSelect2 from "../../components/NDCSelect2"
import FeedbackPanel from "../../components/FeedbackPanel"
import Select2 from "../../components/Select2";
import Vue from "vue";

export default {
	name: "LineItemEdit",
	components: {
		Select2,
		FeedbackPanel,
		NDCSelect2
	},
	extends: BaseEdit,
	mixins: [lineItemMixin],
	methods: {
		cancelEdit: function () {
			this.$router.push({
				name: 'line-item-view',
				params: {id: this.recordId}
			})
		},
		isReportable: function () {
			let reportableSkeds = ['1',
				'1N',
				'2',
				'2N'];
			return reportableSkeds.includes(this.record.fieldData['NDC Schedule'])
		},
		validateNDC: function () {
			if (!this.record.fieldData['NDC Number']) {
				this.pushError({
					type: 'WARNING',
					message: 'NDC Number cannot be empty'
				});
				return false
			}
			return true
		},
		validateNDCSked: function () {
			let valueList = this.record.fieldData['Registration::Schedules'].split('\r');
			if (valueList.includes(this.record.fieldData['NDC Schedule'])) {
				return true
			}
			this.pushError({
				type: 'WARNING',
				message: 'The current registration does not support the selected NDC'
			});
			return false
		},
		validatePackSizeUoM: function () {
			let returnValue = true;

			let packSize = this.record.fieldData['Pack Size'];
			let packUoM = this.record.fieldData['Pack Size UoM'];

			if (packUoM.toUpperCase() === 'D' && packSize % 12 !== 0) {
				this.pushError({
					type: 'WARNING',
					message: 'Pack size must be a multiple of 12 when UoM is dozens (D)'
				});
				$('#pack-size-uom').focus();
				returnValue = false
			}


			if (packUoM.toUpperCase() === 'K' && packSize % 1000 !== 0) {
				this.pushError({
					type: 'WARNING',
					message: 'Pack size must be a multiple of 1000 when UoM is thousands (K)'
				});
				$('#pack-size-uom').focus();
				returnValue = false
			}

			return returnValue
		},
		validateBulkBlendConversion: function () {
			let packSize = this.record.fieldData['YI Package Size Bulk Blend'];
			let stage = this.record.fieldData['YI Package Size Bulk Blend Chosen Stage'];

			let returnValue = true;
			if (packSize && packSize.length === 0 && stage && stage.length > 0) {
				this.pushError({
					type: 'WARNING',
					message: 'If unit converter stage is specified, then unit converter amount cannot be empty'
				});
				$('#bulk-blend-pack-size').focus();
				returnValue = false
			}
			return returnValue
		},
		validatePackQty: function () {
			let packQty = this.record.fieldData['Pack Quantity'];
			let packQtyAsString = packQty.toString();
			let returnValue = true;

			if (this.isReportable() && packQtyAsString.indexOf('.') !== -1) {
				this.pushError({
					type: 'WARNING',
					message: 'Pack quantity cannot contain a decimal'
				});
				$('#pack-qty').focus();
				returnValue = false
			}

			return returnValue
		},
		validatePercentFill: function () {
			let bulkRawPowder = this.record.fieldData['Danox_Dictionary::Bulk Raw Powder LU'];
			let returnValue = true;

			if (bulkRawPowder && bulkRawPowder === 'Yes' && this.record.fieldData['Percent Fill'] > 1.05) {
				this.pushError({
					type: 'WARNING',
					message: 'Percent fill for bulk raw powders cannot exceed 105%'
				});
				returnValue = false
			}

			let bulkRawLiquid = this.record.fieldData['Danox_Dictionary::Bulk Raw Liquid LU'];

			if (bulkRawLiquid && bulkRawLiquid === 'Yes' && this.record.fieldData['Percent Fill'] > 1) {
				this.pushError({
					type: 'WARNING',
					message: 'Percent fill for bulk raw liquids cannot exceed 100%'
				});
				returnValue = false
			}

			return returnValue
		},
		validatePackSize: function () {
			let packSize = this.record.fieldData['Pack Size'];
			let packSizeAsString = packSize.toString();
			let packSizeNoDecimal = packSizeAsString.replace('\\.',
				'');
			let returnValue = true;

			/*if (this.isReportable() && packSize.indexOf('.') !== -1) {
                this.pushError({
                    type: 'WARNING',
                    message: 'Pack size cannot contain decimal because NDC schedule is reportable'
                })
      $('#pack-size').focus()
                returnValue = false
            }*/

			if (this.isReportable() && packSizeNoDecimal.length > 8) {
				this.pushError({
					type: 'WARNING',
					message: 'Pack size cannot exceed 8 digits (excluding a decimal)'
				});
				$('#pack-size').focus();
				returnValue = false
			}

			let uom = this.record.fieldData['Pack Size UoM'];
			let noDecimalUoMs = ['U',
				'K',
				'D',
				'u',
				'k',
				'd'];

			if (this.isReportable() && noDecimalUoMs.includes(uom) && packSizeAsString.indexOf('.') !== -1) {
				this.pushError({
					type: 'WARNING',
					message: 'Pack size cannot contain decimal when reporting dosage form'
				});
				$('#pack-size').focus();
				returnValue = false
			}

			if (this.isReportable() && uom && uom.toUpperCase() === 'ML' && packSizeAsString.indexOf('.') !== -1) {
				this.pushError({
					type: 'WARNING',
					message: 'Quantity reporting in milliliters cannot contain a decimal'
				});
				$('#pack-size').focus();
				returnValue = false
			}

			return returnValue
		},
		validateAndSave: function () {
			this.clearErrors();

			if (
				this.validateBulkBlendConversion() &&
				this.validatePackSize() &&
				this.validatePackQty() &&
				this.validatePercentFill() &&
				this.validatePackSizeUoM()
			) {

				let needsUnitConversion = !!(this.$refs['YI Package Size Bulk Blend'].flags.dirty && this.$refs['YI Package Size Bulk Blend UoM'].flags.dirty);

				let needsStageConversion = !!this.$refs['YI Package Size Bulk Blend Chosen Stage'].flags.dirty;

				let dirtyFields = {}
				this.validationRefs.forEach(value => {
					let validationProvider = this.$refs[value]
					if (validationProvider && validationProvider.flags.dirty) {
						dirtyFields[value] = this.record.fieldData[value]
					}
				})

				this.updateLineItem(
					{
						fieldData: dirtyFields,
						needsStageConversion: needsStageConversion,
						needsUnitConversion: needsUnitConversion,
						isYellowBucket: false
					}
				)
			}
		},
		updateLineItem: function (dirtyFields = null) {
			this.clearErrors();
			Vue.axios.patch('/3ds/api/' + this.entity + '/update-line-item/' + this.recordId,
				dirtyFields,
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					console.log('Successfully updated record');
					console.log(JSON.stringify(value));
					this.$emit('update-record', {
						recordId: this.recordId
					})
				})
				.catch(reason => {
					console.log(JSON.stringify(reason));
					this.authCheck(reason)
				})
		},
		updateNDCLookupData: function (event) {
			if (event.schedule) {
				this.record.fieldData['NDC Schedule'] = event.schedule
			}
			if (event.UoM) {
				this.record.fieldData['Pack Size UoM'] = event.UoM
			}
			if (event.UoMVL) {
				this.record.fieldData['Pack Size UoM'].options = event.UoMVL
			}
		}
	},
	computed: {
		isPercentFillStatic: function () {
			let bulkDosage = this.record.fieldData['Danox_Dictionary::Bulk Dosage Formulation LU'];
			let bulkSolutions = this.record.fieldData['Danox_Dictionary::Bulk Solutions LU'];
			let packSizeUoM = this.record.fieldData['Pack Size UoM'];

			return bulkDosage.toUpperCase() === 'YES' || bulkSolutions.toUpperCase() === 'YES' || packSizeUoM.toUpperCase() === 'K' || packSizeUoM.toUpperCase() === 'D'
		},
		dynamicUomValueList: function () {
			let returnArray = [''];

			if (this.record.fieldData['Danox_Dictionary::UoM_VL']) {
				let valueList = this.record.fieldData['Danox_Dictionary::UoM_VL'].split('\r');
				for (let property in valueList) {
					if (valueList[property] !== 'New Value...')
						returnArray.push({
							'value': valueList[property],
							'text': valueList[property]
						})
				}
			}

			return returnArray
		},
		stagesValueList: function () {
			let returnArray = [''];
			if (this.record.fieldData.Stages_VL) {
				let valueList = this.record.fieldData.Stages_VL.split('\r');
				for (let property in valueList) {
					if (valueList[property] !== 'New Value...')
						returnArray.push({
							'value': valueList[property],
							'text': valueList[property]
						})
				}
			}
			return returnArray
		},
		packQtyTypeValueList: function () {
			let returnArray = [''];
			if (this.record.fieldData.Pack_Quantity_UoM_VL) {
				let valueList = this.record.fieldData.Pack_Quantity_UoM_VL.split('\r');
				for (let property in valueList) {
					if (valueList[property] !== 'New Value...')
						returnArray.push({
							'value': valueList[property],
							'text': valueList[property]
						})
				}
			}
			return returnArray
		}
	},
	data() {
		return {
			validationRefs: [
				'Source Number',
				'Source',
				'Lot Number',
				'Cause',
				'Pack Quantity',
				'Pack Quantity UoM',
				'Percent Fill',
				'Pack Size',
				'Pack Size UoM',
				'YI Package Size Bulk Blend',
				'YI Package Size Bulk Blend UoM',
				'YI Package Size Bulk Blend Chosen Stage'
			],
			sourceOptions: [
				'',
				'Lab',
				'Manufacturer',
				'Production',
				'Product Development',
				'RD Chemistry',
				'Reject',
				'MTI Analytical',
				'MTI R&D',
				'Customer Return',
				'Analytical',
				'Pharmacy',
				'QC',
				'QA Retains',
				'Damage slip',
				'Samples',
				'Packaging',
				'Customer Returns',
				'OSD',
				'MRD',
				'Warehouse',
				'Distributor',
				'Damage',
				'Practitioner',
				'Stability',
				'Complaints',
				'Researcher',
				'QSDB Reject',
				'QA',
				'Tech Services',
				'Exporter',
				'IDT',
				'Clinical Supply Operations',
				'Chemstore'
			],
			causeOptions: [
				"",
				'Off-Spec',
				'Waste',
				'Testing Complete',
				'Expired',
				'Lab Samples',
				'Complaint',
				'Damage',
				'Reject',
				'O2C',
				'Dispensed',
				'Undispensed/Returned',
				'Undisp./Returned',
				'Terminated',
				'Refused',
				'Discontinued'
			],
			yiPkgSizeBulkBlendChosenStageOptions: [
				''
			],
			yiPkgSizeBulkBlendUoMOptions: [
				'',
				'kg',
				'g',
				'mg',
				'mcg',
			],
			ndcLookupData: {},
			initialNdcData: {},
		}
	},
	mounted: function () {
		this.initialNdcData.id = this.record.fieldData['NDC Number'];
		this.initialNdcData.description = this.record.fieldData['NDC Description'];
		this.initialNdcData.strength = this.record.fieldData['Danox_Dictionary::Strength'];
		this.initialNdcData.schedule = this.record.fieldData['NDC Schedule'];
		this.initialNdcData.UoM = this.record.fieldData['Pack Size UoM LU'];
		this.initialNdcData.packSize = this.record.fieldData['ZIPackage Size']
	},
	beforeRouteEnter: function (to, from, next) {
		console.log('Before enter from route ' + from.name + ' to route ' + to.name);
		if (from.name !== 'line-item-view' && from.name !== 'container-view') {
			router.replace({
				name: 'line-item-view',
				params: to.params
			})
		} else {
			next()
		}
	},
	beforeRouteUpdate: function (to, from, next) {
		console.log('Before update from route ' + from.name + ' to route ' + to.name);
		if (from.name !== 'line-item-view' && from.name !== 'container-view') {
			this.$router.replace({
				name: 'line-item-view',
				params: to.params
			})
		} else {
			next()
		}
	}
}
</script>

<style scoped>
.custom-select {
    padding-left: 0.5em
}

.converter-divider {
    border-left: 1px solid rgba(0,
    0,
    0,
    0.1) !important
}

.form-control {
    padding-left: 0.5em;
    padding-right: 0.5em
}
</style>